import Vue from 'vue'
import VueRouter from 'vue-router'
import { getPageSid, B } from "@/static/js/mta_analysis";
import Base from '../views/layouts/Base.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/homepage',
    component: Base,
    children: [
      {
        path: "homepage",
        name: 'index',
        meta: { title: '博库信息技术--首页' },
        component: () => import("../views/homepage/index.vue")
      },
      // 动态中心
      {
        path: "/dynamic",
        name: 'dynamic-center',
        meta: { title: '动态中心' },
        component: () => import("../views/dynamic-center/index.vue")
      },
      // 动态中心详情
      {
        path: "/dynamic/detail",
        name: 'dynamic-center-detail',
        meta: { title: '动态中心详情' },
        component: () => import("../views/dynamic-center/detail.vue")
      },
      // 客户案例
      {
        path: "/customer-case",
        name: 'customer-case',
        meta: { title: '客户案例' },
        component: () => import("../views/customer-case/index.vue")
      },
      // 联系合作
      {
        path: "/contact",
        name: 'contact',
        meta: { title: '联系合作' },
        component: () => import("../views/contactus/index.vue")
      },
      // 关于我们
      {
        path: "/aboutus",
        name: 'aboutus',
        meta: { title: '关于我们' },
        component: () => import("../views/aboutus/index.vue")
      },
      // 图书馆场景方案
      {
        path: "/scene/totalSolution",
        name: "totalSolution",
        meta: { title: '智慧图书馆整体解决方案' },
        component: () => import("../views/scenePlan/libTotalsolve/index.vue")
      },
      {
        path: "/scene/RFID",
        name: "RFID",
        meta: { title: 'RFID图书馆解决方案' },
        component: () => import("../views/scenePlan/libRFIDsolve/index.vue")
      },
      {
        path: "/scene/headBranch",
        name: "headBranch",
        meta: { title: '图书馆总分馆解决方案' },
        component: () => import("../views/scenePlan/libHeadBranch/index.vue")
      },
      {
        path: "/scene/Ubiquitous",
        name: "Ubiquitous",
        meta: { title: '泛在图书馆解决方案' },
        component: () => import("../views/scenePlan/libUbiquitous/index.vue")
      },
      {
        path: "/scene/toFeel",
        name: "tofeel",
        meta: { title: '感知图书馆解决方案' },
        component: () => import("../views/scenePlan/libTofeel/index.vue")
      },
      {
        path: "/scene/interact",
        name: "interact",
        meta: { title: '互动图书馆解决方案' },
        component: () => import("../views/scenePlan/libInteract/index.vue")
      },
      {
        path: "/scene/webthings",
        name: "webthings",
        meta: { title: '图书馆物联网解决方案' },
        component: () => import("../views/scenePlan/libWebthings/index.vue")
      },
      {
        path: "/scene/antiepidemic",
        name: "antiepidemic",
        meta: { title: '图书馆防疫解决方案' },
        component: () => import("../views/scenePlan/libAntiepidemic/index.vue")
      },
      // 图书馆特色方案
      {
        path: "/special/public",
        name: "public",
        meta: { title: '公共图书馆' },
        component: () => import("../views/specialPlan/libPublic/index.vue")
      },
      {
        path: "/special/primaryschool",
        name: "primaryschool",
        meta: { title: '中小学图书馆' },
        component: () => import("../views/specialPlan/libPrimaryschool/index.vue")
      },
      {
        path: "/special/highschool",
        name: "highschool",
        meta: { title: '高校图书馆' },
        component: () => import("../views/specialPlan/libHighschool/index.vue")
      },
      {
        path: "/special/enterprise",
        name: "enterprise",
        meta: { title: '企事业图书馆' },
        component: () => import("../views/specialPlan/libEnterprise/index.vue")
      },
      {
        path: "/special/city",
        name: "city",
        meta: { title: '城市书房' },
        component: () => import("../views/specialPlan/libCity/index.vue")
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
router.beforeEach((to, from, next) => {
  var toPath = to.path
  var fromPath = from.path
  switch (toPath) {
    case '/homepage':
      B("博库信息技术-首页", "首页", getPageSid(), "visit")
      break;
    case '/dynamic':
      B("博库信息技术-动态中心", "动态中心", getPageSid(), "visit")
      break;
    case '/dynamic/detail':
      B("博库信息技术-动态中心详情", "动态中心详情", getPageSid(), "visit")
      break;
    case '/customer-case':
      B("博库信息技术-客户案例", "客户案例", getPageSid(), "visit")
      break;
    case '/contact':
      B("博库信息技术-联系合作", "联系合作", getPageSid(), "visit")
      break;
    case '/aboutus':
      B("博库信息技术-关于我们", "关于我们", getPageSid(), "visit")
      break;
    case '/scene/totalSolution':
      B("博库信息技术-智慧图书馆", "智慧图书馆", getPageSid(), "visit")
      break;
    case '/scene/RFID':
      B("博库信息技术-RFID图书馆", "RFID图书馆", getPageSid(), "visit")
      break;
    case '/scene/headBranch':
      B("博库信息技术-图书馆总分馆", "图书馆总分馆", getPageSid(), "visit")
      break;
    case '/scene/Ubiquitous':
      B("博库信息技术-泛在图书馆", "泛在图书馆", getPageSid(), "visit")
      break;
    case '/scene/toFeel':
      B("博库信息技术-感知图书馆", "感知图书馆", getPageSid(), "visit")
      break;
    case '/scene/interact':
      B("博库信息技术-互动图书馆", "互动图书馆", getPageSid(), "visit")
      break;
    case '/scene/webthings':
      B("博库信息技术-图书馆物联网", "图书馆物联网", getPageSid(), "visit")
      break;
    case '/scene/antiepidemic':
      B("博库信息技术-图书馆防疫", "图书馆防疫", getPageSid(), "visit")
      break;
    case '/special/public':
      B("博库信息技术-公共图书馆", "公共图书馆", getPageSid(), "visit")
      break;
    case '/special/primaryschool':
      B("博库信息技术-中小学图书馆", "中小学图书馆", getPageSid(), "visit")
      break;
    case '/special/highschool':
      B("博库信息技术-高校图书馆", "高校图书馆", getPageSid(), "visit")
      break;
    case '/special/enterprise':
      B("博库信息技术-企事业图书馆", "企事业图书馆", getPageSid(), "visit")
      break;
    case '/special/city':
      B("博库信息技术-城市书房", "城市书房", getPageSid(), "visit")
      break;
    default:
      break;
  }
  switch (fromPath) {
    case '/homepage':
      B("博库信息技术-博库信息技术-首页", "首页", getPageSid(), "leave")
      break;
    case '/dynamic':
      B("博库信息技术-动态中心", "动态中心", getPageSid(), "leave")
      break;
    case '/dynamic/detail':
      B("博库信息技术-动态中心详情", "动态中心详情", getPageSid(), "leave")
      break;
    case '/customer-case':
      B("博库信息技术-客户案例", "客户案例", getPageSid(), "leave")
      break;
    case '/contact':
      B("博库信息技术-联系合作", "联系合作", getPageSid(), "leave")
      break;
    case '/aboutus':
      B("博库信息技术-关于我们", "关于我们", getPageSid(), "leave")
      break;
    case '/scene/totalSolution':
      B("博库信息技术-智慧图书馆", "智慧图书馆", getPageSid(), "leave")
      break;
    case '/scene/RFID':
      B("博库信息技术-RFID图书馆", "RFID图书馆", getPageSid(), "leave")
      break;
    case '/scene/headBranch':
      B("博库信息技术-图书馆总分馆", "图书馆总分馆", getPageSid(), "leave")
      break;
    case '/scene/Ubiquitous':
      B("博库信息技术-泛在图书馆", "泛在图书馆", getPageSid(), "leave")
      break;
    case '/scene/toFeel':
      B("博库信息技术-感知图书馆", "感知图书馆", getPageSid(), "leave")
      break;
    case '/scene/interact':
      B("博库信息技术-互动图书馆", "互动图书馆", getPageSid(), "leave")
      break;
    case '/scene/webthings':
      B("博库信息技术-图书馆物联网", "图书馆物联网", getPageSid(), "leave")
      break;
    case '/scene/antiepidemic':
      B("博库信息技术-图书馆防疫", "图书馆防疫", getPageSid(), "leave")
      break;
    case '/special/public':
      B("博库信息技术-公共图书馆", "公共图书馆", getPageSid(), "leave")
      break;
    case '/special/primaryschool':
      B("博库信息技术-中小学图书馆", "中小学图书馆", getPageSid(), "leave")
      break;
    case '/special/highschool':
      B("博库信息技术-高校图书馆", "高校图书馆", getPageSid(), "leave")
      break;
    case '/special/enterprise':
      B("博库信息技术-企事业图书馆", "企事业图书馆", getPageSid(), "leave")
      break;
    case '/special/city':
      B("博库信息技术-城市书房", "城市书房", getPageSid(), "leave")
      break;
    default:
      break;
  }
  const title = to.meta.title
  if (title) {
    document.title = title
  }
  next()
})
router.afterEach((to, from) => {
  console.log(to, from);
  document.documentElement.scrollTop = 0

})

export default router
